/* Priyanka Musical House — global behaviour (bottom nav, live cart count). Vanilla JS. */
(function () {
  'use strict';

  function isVisible(el) {
    if (!el) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  /* ---------- Bottom navigation ---------- */
  function openMenuDrawer() {
    var summary = document.querySelector('header-drawer summary');
    if (summary && isVisible(summary)) {
      var details = summary.closest('details');
      if (details && details.hasAttribute('open')) {
        summary.click();
        return true;
      }
      var hdr = document.querySelector('.section-header');
      if (hdr) hdr.classList.remove('animate', 'shopify-section-header-hidden');
      summary.click();
      var hd = document.querySelector('header-drawer');
      setTimeout(function () {
        if (hd && typeof hd.onResize === 'function') hd.onResize();
      }, 200);
      return true;
    }
    return false;
  }

  function openSearch() {
    var summaries = document.querySelectorAll(
      'details-modal.header__search summary, .header__search summary, .header__icon--search'
    );
    for (var i = 0; i < summaries.length; i++) {
      if (isVisible(summaries[i])) {
        summaries[i].click();
        return true;
      }
    }
    // Inline search input (if the header shows one on mobile)
    var input = document.querySelector('.header input[type="search"]');
    if (input && isVisible(input)) {
      input.focus();
      return true;
    }
    return false;
  }

  function openCart() {
    if (!document.querySelector('cart-drawer')) return false;
    if (window.routes && window.location.pathname === window.routes.cart_url) return false;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      bubble.click();
      return true;
    }
    return false;
  }

  function initBottomNav() {
    var nav = document.querySelector('[data-pmh-bottom-nav]');
    if (!nav || nav.dataset.pmhReady) return;
    nav.dataset.pmhReady = 'true';

    nav.addEventListener('click', function (event) {
      var link = event.target.closest('[data-pmh-nav]');
      if (!link) return;
      var action = link.getAttribute('data-pmh-nav');
      var handled = false;
      try {
        if (action === 'menu') handled = openMenuDrawer();
        else if (action === 'search') handled = openSearch();
        else if (action === 'cart') handled = openCart();
      } catch (e) {
        handled = false;
      }
      // If a Dawn drawer handled it, stop navigation; otherwise the href
      // (/collections, /search, /cart) works as a normal link.
      if (handled) event.preventDefault();
    });
  }

  /* ---------- Live cart count ---------- */
  function setCartCount(count) {
    count = parseInt(count, 10) || 0;
    document.querySelectorAll('[data-pmh-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-pmh-cart-count-text]').forEach(function (el) {
      el.textContent = count + (count === 1 ? ' item in cart' : ' items in cart');
    });
    document.querySelectorAll('[data-pmh-cart-count-label]').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + (count === 1 ? ' item)' : ' items)') : '';
    });
  }

  function refreshCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') setCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  function initCartCount() {
    if (typeof window.subscribe === 'function' || typeof subscribe === 'function') {
      var sub = typeof window.subscribe === 'function' ? window.subscribe : subscribe;
      var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
      if (events && events.cartUpdate) {
        sub(events.cartUpdate, function (event) {
          var data = event && event.cartData;
          if (data && typeof data.item_count === 'number') setCartCount(data.item_count);
          else refreshCartCount();
        });
      }
    }
    // Back/forward cache: page restored with a stale count.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshCartCount();
    });
  }

  function init() {
    initBottomNav();
    initCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init if sections reload.
  document.addEventListener('shopify:section:load', initBottomNav);

  window.PMH = window.PMH || {};
  window.PMH.setCartCount = setCartCount;
  window.PMH.refreshCartCount = refreshCartCount;
})();
